import { GenericObject } from "../custom-types/generic-object";

export function getUniqueArray<T>(arr: T[], key?: string) {
    if (typeof arr === "object" && key) {
        const newArr: T[] = [];
        arr.forEach((item) => {
            if (!newArr.find((a) => (a as GenericObject)[key] === (item as GenericObject)[key])) {
                newArr.push(item);
            }
        });
        return newArr;
    } else {
        return [...new Set(arr)];
    }
}
